module.exports = __webpack_public_path__ + "img/payment_setting.f48ce1cc.svg";